"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/xs/controllers/propsible');
const base_class_1 = require("../controllers/base.class");
const Constants_1 = require("@src/app/commons/Constants");
const Hash = require('object-hash');
/*
  Propsible handles collections of properties, with caching and change detection (so you don't have to)
*/
class XsPropsible extends base_class_1.XsBaseClass {
    constructor(config = {}) {
        super(config);
        this.debugId = 'PROPSIBLE';
        // our properties schema
        this.schema = {};
        // cached and compiled schemas
        this.schemaCompiled = null;
        this.hashed = {};
        // our configuration
        this.config = null;
        // incoming original properties
        this.propertiesOriginal = null;
        // our property store
        this.properties = {};
        // just the names of properties
        this.propertiesNames = [];
        // console.log( this.debugId + ' :: CONSTRUCTOR');
        DEBUG_1.DEBUG.log('/xs/controllers/propsible');
    }
    static uuidGuessHashes(uuid, keys) {
        if (XsPropsible.uuidGuesses[uuid]) {
            return XsPropsible.uuidGuesses[uuid];
        }
        XsPropsible.uuidGuesses[uuid] = [];
        // guess a few common property names
        const guesses = ['id', 'uid', 'uuid', 'guid', 'objectid', 'object_id', 'itemid', 'item_id', 'count', 'count0', 'idx'];
        // uneducated guessing; to create a sensible hash, use only any of these properties if found (we're looking for as unique as possible)
        keys.forEach(key => {
            if (guesses.find(f => f == key) || guesses.find(f => '_' + f == key) || guesses.find(f => f.toUpperCase() == key) || guesses.find(f => '_' + f.toUpperCase() == key)) {
                XsPropsible.uuidGuesses[uuid].push(key);
            }
        });
        // console.log('######## once per Transform #######', uuid, XsPropsible.uuidGuesses[uuid], keys );
        return XsPropsible.uuidGuesses[uuid];
    }
    static analyzeProperties(t, incomingProps, debug = 'unknown') {
        if (!t['__properties']) {
            t['__properties'] = {};
        }
        let properties = t['__properties'];
        if (!properties.___lut) {
            properties.___lut = {};
        }
        // console.log('###propsIncomingAnalyze()', debug, incomingProps );
        if (!incomingProps) {
            return null;
        }
        const keys = Object.keys(incomingProps);
        // to create a hash, use these keys
        let hashKeys = XsPropsible.uuidGuessHashes('t_' + t.id, keys);
        // let bug = {};
        // is there any keys?
        if (keys[0]) {
            // just match the first key with its incomingProps. All incomingProps are of the same length, so if you've got
            // propA and propB, they both should have the same number of array items, for example propA[23] and propB[23]
            // so n (below) is an index of which "column" we're looking at
            const p = incomingProps[keys[0]];
            if (p && p.length) {
                // loop through all the columns
                for (let n = 0; n < p.length; n++) {
                    // new item; what we're discovering
                    let item = {};
                    let propkey = '';
                    // first, copy in only the properties we want to make a hash from 
                    hashKeys.forEach(k => {
                        const p = incomingProps[k][n];
                        if (p) {
                            item[k] = p;
                            propkey = propkey + '$' + k + '=' + p;
                        }
                    });
                    // figure out and add the hash
                    let hash = Hash(item);
                    item['___hash'] = hash;
                    item['___propkey'] = propkey;
                    item['___idx'] = n;
                    // if ( item['id'] && item['id'] == '532' ) { console.info ( '####### 532', hash, item, propkey ); }
                    // copy in all values
                    keys.forEach(k => {
                        const p = incomingProps[k][n];
                        if (p) {
                            item[k] = p;
                        }
                    });
                    /*
                    if ( !properties.luthash[hash] ) {
                      properties.luthash[hash] = [];
                    }
                    if ( !properties.luthash[hash+'$$'] ) {
                      properties.luthash[hash+'$$'] = [];
                    }
                    */
                    if (!properties.___lut[hash]) {
                        properties.___lut[hash] = item;
                        // properties.luthash[hash].push(propkey);
                    }
                    else {
                        // properties.luthash[hash+'$$'].push(propkey);
                    }
                    /*
                    if ( !properties.lutid[propkey] ) {
                      properties.lutid[propkey] = [];
                    }
                    properties.lutid[propkey].push(hash);
                    */
                    // res[n] = item;
                    // bug[n] = item;
                }
                // Object.keys(lut).forEach ( item => {})
            }
        }
        // console.log('##PROPS_static incomingAnalyze()', debug, keys, properties );
        /*
        keys.forEach ( key => {
          const p = props[key];
          if ( !templates[key] ) {
            templates[key] = {
              ___key:key,
              ___idx:null,
              ___id:null,
              ___type:null,
              ___length:null
            };
          }
          if ( typeof p == 'object' ) {
            if ( Array.isArray(p) ) {
              templates[key].___type = 'array';
              templates[key].___length = p.length;
            } else {
              templates[key].___type = 'object';
              templates[key].___length = Object.keys(p).length;
            }
          } else {
            templates[key].___type = typeof p;
          }
          templates[key][key] = [];
        });
        
        keys.forEach ( key => {
          let idxObject = { ...templates[key] };
          if ( idxObject.___type == 'array' ) {
            for ( let n=0; n<idxObject.___length; n++ ) {
              idxObject.___idx = n;
              keys.forEach ( k => {
                const p = props[k][n];
                if ( p ) {
                  idxObject[k] = p;
                }
              });
            }
    
          }
        });
        */
        /*
            let idMethod = 0;
            if ( keys.find( f => f == 'id' )) {
              idMethod = 1;
            }
        
            keys.forEach ( key => {
        
              const p = props[key];
        
              let id = null;
              
        
              
        
              if ( !properties[key] ) {
                properties[key] = {
                  _id: null,
                  _lengths: { null_total:0, null_unique:0, string_total:0, string_unique:0, number_total:0, number_unique:0 },
                  _stream: []
                };
              }
              
              if ( typeof p == 'object' ) {
                if ( Array.isArray(p) ) {
        
                  let hasher = {};
                  if ( idMethod ) {
                    // there's an id field
                    id = p['id'];
                  } else {
                    // default
        
                  }
        
                  // array
                  p.forEach( v => {
        
                    properties[key]._stream.push(v);
        
                    const t = Typical.check(v);
        
                    if ( !properties[key][t] ) {
                      properties[key][t] = {};
                    }
                    if ( !properties[key][t][v] ) {
                      properties[key][t][v] = 0;
                      properties[key]._lengths[t+'_unique']++;
                    }
                    properties[key][t][v]++;
                    properties[key]._lengths[t+'_total']++;
        
                  });
                } else {
                  // object
        
                  // normally we would have to parse the object, find the right place in the batchtable, etc. however
                  // we use the Cesium property API to build the incoming structure instead, so this object section
                  // shold never happen *fingers crossed*
                  
                  console.log('$ propsIncoming prop is object')
                  const t = Typical.check(p);
                  if ( !properties[key][t] ) {
                    properties[key][t] = [];
                  }
                  let s = [];
                  // for (const [key, value] of Object.entries(p)) {
                  //   s.push(key + '=' + value);
                  // }
                  properties[key][t].push( s.join(' | ') );
                  
                }
              }
            }); */
    }
    getPropertyNames() {
        return this.propertiesNames.sort(function (a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
    }
    getProperty(key = null) {
        return this.properties[key];
    }
    populate(properties = null) {
        if (!properties) {
            return null;
        }
        const lut = properties['___lut'];
        if (lut) {
            Object.keys(lut).forEach(hash => {
                let item = lut[hash];
                if (item) {
                    Object.keys(item).forEach(key => {
                        if (key.substr(0, 3) !== '___') {
                            const propkey = item['___propkey'];
                            this.hashed[propkey] = item;
                            const value = item[key];
                            const type = Constants_1.Typical.check(value);
                            if (!this.properties[key]) {
                                this.properties[key] = {
                                    ___id: this.__uuidv4(),
                                    ___hashedItem: hash,
                                    ___type: this.sniffType(value),
                                    ___lengths: { null_total: 0, null_unique: 0, string_total: 0, string_unique: 0, number_total: 0, number_unique: 0 },
                                    ___stream: [],
                                    ___unique: {}
                                };
                            }
                            if (!this.properties[key].___unique[value]) {
                                this.properties[key].___unique[value] = 0;
                                this.properties[key].___lengths[type + '_unique']++;
                            }
                            this.properties[key].___unique[value]++;
                            this.properties[key].___lengths[type + '_total']++;
                            if (!this.properties[key][type]) {
                                this.properties[key][type] = 0;
                            }
                            this.properties[key][type]++;
                        }
                    });
                }
            });
        }
        // console.log('!!populate()', lut, properties );
        if (typeof properties == 'object' && !Array.isArray(properties)) {
            // an object store
            // console.log('!!obj');
            Object.keys(properties).forEach(key => {
                if (key.substr(0, 3) !== '___') {
                    let property = properties[key];
                    // this.properties[key+'_raw'] = property;
                    if (property) {
                        const type = typeof property;
                        if (type == 'object') {
                            this.schema[key] = this.sniffObjectType(property);
                        }
                        else {
                            this.properties[key] = property;
                            this.schema[key] = { data: null, unique: 0, type: type };
                        }
                        // this.propertiesNames.push(key);
                    }
                }
            });
        }
        else {
            // an array
            // console.log('!!arr');
        }
        this.propertiesNames = Object.keys(this.properties);
    }
    sniffType(property) {
        const type = typeof property;
        let ret = type;
        return ret;
    }
    sniffObjectType(property) {
        let ret = { data: property, type: 'object' };
        const keys = Object.keys(property);
        if (keys.length) {
            ret.type = 'null';
            // has props. Let's check further
            if (property['minimum'] || property['maximum']) {
                ret.type = 'number';
            }
        }
        else {
            // blank; treat as string
            ret.type = 'string';
        }
        return ret;
    }
    propertyType(prop) {
        // console.log('!!!!! property', prop );
        if (prop) {
            if (prop['string'] && prop['number']) {
                // console.log('!!!!! property error : multiple types', prop );
                return 'multiple';
            }
            else {
                if (prop['string']) {
                    return 'string';
                }
                else if (prop['number']) {
                    return 'number';
                }
                else {
                    return 'null';
                }
            }
        }
        else {
            return 'error';
        }
    }
    propertyLength(prop, type) {
        if (prop && prop.___lengths && prop.___lengths[type + '_unique']) {
            return prop.___lengths[type + '_unique'];
        }
        return 0;
    }
    propertyMap(prop, type) {
        let ret = [];
        if (!prop) {
            return ret;
        }
        // if ( type == 'string' || type == 'number' ) {}
        if (prop['___unique']) {
            ret = Object.keys(prop['___unique']);
            /*
            Object.keys(prop[type]).forEach ( key => {
                ret.push
            });
            for ( let n=0; n<prop[type].length; n++ ) {
                ret = prop[type];
            }
            */
        }
        return ret;
    }
}
XsPropsible.uuidGuesses = {};
exports.XsPropsible = XsPropsible;
